// Operator-Session — bewusst getrennt vom Sachbearbeiter-Token (`bmd_cloud_tokens`)
// und der Klient-Session. Höchstprivilegierter Zugang → eigener Storage-Schlüssel.
// Access + Refresh (anders als der Klient, der keinen Refresh hat).

const OPERATOR_SESSION_KEY = "fidena_operator_session";

export interface OperatorSession {
  access_token: string;
  refresh_token: string;
}

export function getOperatorSession(): OperatorSession | null {
  try {
    const raw = window.localStorage.getItem(OPERATOR_SESSION_KEY);
    return raw ? (JSON.parse(raw) as OperatorSession) : null;
  } catch {
    return null;
  }
}

export function setOperatorSession(session: OperatorSession | null): void {
  if (session) {
    window.localStorage.setItem(OPERATOR_SESSION_KEY, JSON.stringify(session));
  } else {
    window.localStorage.removeItem(OPERATOR_SESSION_KEY);
  }
}

export function clearOperatorSession(): void {
  setOperatorSession(null);
}
